
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1360","height":"127","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1360 0H0v126.14h1360V0z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M1280 126.14v-.44c0-8.14 2.28-14.73 5.1-14.73s5.1 6.59 5.1 14.73v.44H1280zM1280 0v.45c0 8.13 2.28 14.72 5.1 14.72s5.1-6.59 5.1-14.72V0H1280zM73 0v.45c0 8.13 2.28 14.72 5.1 14.72S83.2 8.58 83.2.45V0H73zm0 126.14v-.44c0-8.14 2.28-14.73 5.1-14.73s5.1 6.59 5.1 14.73v.44H73z","fill":"#fff"}}),_c('path',{attrs:{"d":"M176.94 40.9h-77v44h77v-44z","fill":"#666"}}),_c('path',{attrs:{"d":"M159.94 51.9h-42v18h42v-18z","fill":"#1A1A1A"}}),_c('path',{attrs:{"d":"M1252.94 38.9h-77v44h77v-44z","fill":"#666"}}),_c('path',{attrs:{"d":"M1235.94 49.9h-42v18h42v-18z","fill":"#1A1A1A"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h1360v126.14H0z"}})])])])
          )
        }
      }
    